import { render, staticRenderFns } from "./evento.vue?vue&type=template&id=7b4d0e12&scoped=true&"
import script from "./evento.vue?vue&type=script&lang=js&"
export * from "./evento.vue?vue&type=script&lang=js&"
import style0 from "./evento.vue?vue&type=style&index=0&id=7b4d0e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d0e12",
  null
  
)

export default component.exports